import { apiCap } from "@gik/api";
import { useInkindSituations } from "@gik/api/situation/situation";
import type { UIComponent } from "@gik/core/types/UI";
import bemBlock from "@gik/core/utils/bemBlock";
import withComponentErrorBoundary from "@gik/core/utils/withComponentErrorBoundary";
import { LoadingSpinner } from "@gik/ui-legacy/LoadingSpinner";
import type React from "react";
import SituationTile from "./SituationTile";

export const SituationsOverviewGridBlockName = "situations-overview-grid";

export interface ISituation {
	id: string;
	imageUrl: string;
}

export type SituationsOverviewGridProps = {
	// items: WordpressSituation[];
} & UIComponent;

function SituationsOverviewGridComp({
	className,
}: SituationsOverviewGridProps): React.ReactElement {
	const bem = bemBlock(SituationsOverviewGridBlockName);

	const { data: situations, error: situationsError } = useInkindSituations({
		page: 1,
		perPage: apiCap,
	});

	const isLoading = !situations;
	const isError = isLoading && situationsError;

	if (isLoading) return <LoadingSpinner />;
	if (isError) return <LoadingSpinner />;

	if (situations?.length === 0) {
		return <div className={bem("empty")}>No situations found.</div>;
	}

	return (
		<div className={bem(null, null, [className, "gik-flex-grid"])}>
			{situations?.map((situation) => {
				return (
					<SituationTile
						key={situation.id}
						title={situation.name}
						imageUrl={situation.acf.taxonomy_svg_icon_alt}
					/>
				);
			})}
		</div>
	);
}

export const SituationsOverviewGrid = withComponentErrorBoundary(
	SituationsOverviewGridComp,
);
